import React from "react"
import thingsflow from "../assets/images/company/thingsflow.png"
import class101 from "../assets/images/company/class101.png"
import sparta from "../assets/images/company/sparta.png"
import { ReactNode } from "react"

export interface Testimonial {
  link: string
  content: {
    en: ReactNode
    ko: ReactNode
  }
  company: {
    logoSrc: string
    name: {
      en: string
      ko: string
    }
  }
  writer: {
    job: string
    name: {
      en: string
      ko: string
    }
  }
}

const testimonials: Testimonial[] = [
  {
    link: "",
    content: {
      en: (
        <span>
          <strong>Hackle’s usability</strong> surprised me. I was able to jump right into experimentating and A/B
          testing with various ideas while significantly reducing the amount of resources required.
        </span>
      ),
      ko: (
        <span>
          처음 핵클을 접했을 때, <strong>사용방법이 너무 간단해서 놀랐습니다.</strong> 누구나 쉽게 테스트를 할 수 있다
          보니, 다양한 아이디어들을 빠르게 실험해 보면서도 투여되는 <strong>리소스를 줄일 수 있었습니다.</strong>
        </span>
      ),
    },
    company: {
      logoSrc: thingsflow,
      name: {
        en: "Thingsflow",
        ko: "띵스플로우",
      },
    },
    writer: {
      job: "Backend Engineer",
      name: {
        en: "",
        ko: "손용기",
      },
    },
  },
  {
    link: "",
    content: {
      en: (
        <span>
          <strong>With Hackle’s feature flags</strong>, newly released feature could be turned off immediately, making
          it much easier to respond to incidents.
        </span>
      ),
      ko: (
        <span>
          <strong>기능플래그</strong>로 배포한 경우 문제가 생기면 바로 꺼버리면 되기 때문에
          <strong> 장애 대응이 훨씬 쉬워졌습니다.</strong> 기능플래그는 애자일 개발을 지향하는 개발팀이라면 필수적으로
          써야하는 기능이라고 생각합니다.
        </span>
      ),
    },
    company: {
      logoSrc: class101,
      name: {
        en: "CLASS101",
        ko: "클래스101",
      },
    },
    writer: {
      job: "Engineering Manager",
      name: {
        en: "",
        ko: "배현승",
      },
    },
  },
  {
    link: "",
    content: {
      en: (
        <span>
          With Hackle's A/B Test, we were able to validate different items{" "}
          <strong>within the critical path flow</strong> and release only the optimized features. Running frequent A/B
          tests was <strong>much faster</strong> using Hackle compared to manually running them in-house.
        </span>
      ),
      ko: (
        <span>
          핵클 도입 이후 <strong>Critical path는 확실하게 A/B 테스트로 검증</strong>한 후 출시할 수 있어서 좋았습니다.
          인하우스에서 <strong>직접 개발해서 A/B 테스트를 진행할 때보다 속도가 더 빨라졌습니다.</strong>
        </span>
      ),
    },
    company: {
      logoSrc: sparta,
      name: {
        en: "Team Sparta",
        ko: "팀스파르타",
      },
    },
    writer: {
      job: "CMO",
      name: {
        en: "",
        ko: "황순영",
      },
    },
  },
]

export default testimonials
